
/**
 * 文本翻译请求
 */
export interface TranslateTextRequest {
    /**
     * 待翻译的文本
     */
    text: string;
    /**
     * 源语言代码（如 'en', 'ko', 'ja' 等）
     */
    from: string;
    /**
     * 目标语言代码（通常为 'zh' - 中文）
     */
    to: string;
}

/**
 * 文本翻译响应
 */
export interface TranslateTextResponse {
    /**
     * 翻译后的文本
     */
    text: string;
}

/**
 * 文本翻译 API
 */
export interface TranslateTextApi {
    /**
     * 翻译文本
     * @param data 翻译请求参数
     * @returns 翻译后的文本
     */
    translateText(data: TranslateTextRequest): Promise<TranslateTextResponse>;
}

export const TranslateTextApi = Symbol('TranslateTextApi');
